var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIconBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H20L26 6V30C26 31.1046 25.1046 32 24 32H2C0.89543 32 0 31.1046 0 30V2Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H20L26 6V30C26 31.1046 25.1046 32 24 32H2C0.89543 32 0 31.1046 0 30V2Z",
    fill: "#F6F6F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6V30C26 31.1046 25.1046 32 24 32H2C0.89543 32 0 31.1046 0 30V2C0 0.895431 0.895431 0 2 0H20M26 6L20 0M26 6H22C20.8954 6 20 5.10457 20 4V0",
    stroke: "#E5E7EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0L26 6H21L20 5V0Z",
    fill: "#E5E7EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconBackground);
export default __webpack_public_path__ + "static/media/file-icon-background.9c95e0819030cee1593595d3d145c976.svg";
export { ForwardRef as ReactComponent };